// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2cbeB","dragIcon":"SortableItem_dragIcon__2TMap","disabled":"SortableItem_disabled__2IfHA"};